import makeStyles from '@mui/styles/makeStyles'
import { MaVehicleBannerClasses, MyAccountTheme } from '@dxp-module/themes'

const vehicleBannerStyles = makeStyles<
  MyAccountTheme,
  object,
  MaVehicleBannerClasses
>(
  ({ typography, palette, breakpoints }) => ({
    root: {
      position: 'relative',
      minHeight: '150px',
    },
    title: {
      fontWeight: typography.fontWeightBold,
      color: palette.primary.main,
    },
    description: {
      maxWidth: '900px',
      color: palette.text.primary,
    },
    textContainer: {
      textAlign: 'center',
      padding: '8px 20px',
      width: '100%',
      position: 'absolute',
      bottom: 0,
      [breakpoints.up('sm')]: {
        marginBottom: '15px',
      },
      [breakpoints.up('md')]: {
        marginBottom: '25px',
      },
      [breakpoints.up('lg')]: {
        marginBottom: '50px',
      },
      [breakpoints.up('xl')]: {
        marginBottom: '60px',
      },
    },
    imageContainer: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
      overflow: 'hidden',
    },
  }),
  { name: 'MyAccount_VehicleBanner' }
)

export default vehicleBannerStyles
